<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {ModelListSelect} from "vue-search-select";
import {mapGetters, mapActions, mapState} from "vuex";
import moment from "moment"

/**
 * Tabs & accordions component
 */
export default {
  page: {
    title: "PATIENT DETAILS",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
    ckeditor: CKEditor.component,
    ModelListSelect,
  },
  data() {
    return {
      modal_id: "",
      editdata: {
        new_name: "",
        id: "",
        age: "",
        age_unit: "",
        temperature: "",
        mauc: "",
        nextofkin: "",
        nextofkincontact: "",
        weight: "",
        height: "",
        pulse: "",
        pressure: "",
        visitdate: "",
      },
      selecteddoc: {},
      radiology_attach: {
        name: "",
        file: "",
        success: "",
        filePreview: "",
        url: "",
        visit_id: this.$route.params.visit,
        patient_service_id: "",
      },
      finalDiagnosisTags: [],
      provisionalDiagnosisTags: [],
      attachments: [],
      serviceresults: [],
      appointment_data: {
        doctor_section: true,
        staff: "",
        location: "",
        appointment_date: "",
        time: "",
        patient_id: this.$route.params.id,
        visit_id: this.$route.params.visit,
      },
      serv_autoselect_type: null,
      isEditing: false,
      test: null,
      value: [],
      options: [],
      DetailsData: [],
      editor: ClassicEditor,
      clinic_data: {
        visit_id: this.$route.params.visit,
        selected: "",
        version: "2",
        patient_complaints: [],
        patient_finalDiagnosis: [],
        patient_provisionalDiagnosis: [],
        complaints_history: "",
        physicalexamination: "",
        finaldiagnosis: "",
        summary: "",
        provisional: "",
        recommendation: "",
        description: "",
        next_date: "",
        time: "",
        appo_status: "0",
      },
      title: "DETAILS",
      items: [
        {
          text: "Doctor",
          href: "#",
        },
        {
          text: "Detail",
          active: true,
        },
      ],
      referral_data: {
        visit_id: this.$route.params.visit,
        to: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        reason: "",
        investigations: ""
      },
      model_id: "",
      // PAGE INFORMATION
      patient_id: this.$route.params.id,
      visit_id: this.$route.params.visit,
      type: this.$route.params.type,
      //  ADD OTHER SYSTEMS
      other_systems: {
        visit_id: this.$route.params.visit,
        system: "",
        diagnosis: "",
        service_id: "",
      },
      // FILTERED SYSTES
      ServiceSystemsArray: [],
      // DRUG PRESCRIPTION
      drug_priscriptins: [{}],
      //  ADD PRESCRIPTION
      priscription: {
        visit_id: this.$route.params.visit,
        drug_id: "",
        age: "",
        age_unit: "",
        is_insured: 0,
      },
      default_dosage:"",
      prescription: {
        drug_id: "",
        quantity: "1",
        rec_dosage: "",
        patientId: "",
        is_insured: "0",
        visit_id: this.$route.params.visit,
      },
      InsError: "",
      drugError: "",
      mdcnError: "",
      qtyError: "",
      serviceError: "",
      priceError: "",
      deptError: "",

      // ADD SERVICE
      service_add: {
        department: "",
        insurance_company: "",
        insurance_status: "0",
        patientId: this.$route.params.id,
        patient_service: "",
        quantity: "1",
        service: "",
        service_cost: "",
        minimum_price:0,
        visit_id: this.$route.params.visit,
      },
      //SPEECH
      selectedVoice: 2,
      synth: window.speechSynthesis,
      voiceList: [],
      warnDoctor: new window.SpeechSynthesisUtterance(),
      // END SPEECH
      warn_status: "0",
      discharge_data: {
        visit_id: this.$route.params.visit,
        admission_date: moment(new Date()).format("YYYY-MM-DD"),
        discharge_date: moment(new Date()).format("YYYY-MM-DD"),
        wards: "",
        status: "",
        officer: "",
        followupdate: "",
        followupplace: "",
        clinical_presentation: "",
        intervation: "",
        reccomendation: "",
      },
    };
  },

  computed: {
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("inpatient", ["DischargeStatuses", "SaveStatus", "ReferHealthUnitsData", "ReferPrintId"]),
    ...mapGetters("staffModule", ["clinic_staff"]),
    ...mapGetters("doctor", [
      "PatientCompalints",
      "DiagnosisDetails",
      "DiagnosisStatus",
      "NotesSaveStatus",
      "FinalDiagnosis",
      "ProvisionalDiagnosis",
    ]),
    ...mapGetters("visits", [
      "OrderedConsultations",
      "OrderedProcedure",
      "OrderedRadiology",
      "OrderedDental",
      "AllOrderedServices",
      "OrderServiceStatus",
    ]),
    ...mapGetters("patients", ["saving_status"]),
    ...mapGetters("pharmacy", ["PharmacyItems","DrugAgeRange"]),
    ...mapGetters("systems", [
      "OtherSystems",
      "PatientOtherSystems",
      "PatientSystemStatus",
    ]),
    ...mapGetters("prescriptions", ["VisitPrescription", "prescriptionStatus"]),
    ...mapGetters("services", [
      "departments",
      "labServices",
      "consultationServices",
      "radiologyServices",
      "procedureServices",
      "dentalServices",
      "antenatalServices",
      "otherServices"
    ]),
    ...mapGetters("appointment", ["Appointment_status", "PatientAppointments"]),
    ...mapGetters("insurance", ["PaymentType", "InsuranceServices"]),
    ...mapGetters("visits", [
      "profileStatus",
      "visit_profile",
    ]),

    // FILTER SERVIVES DEPENDING ON A SELECTED DEPARTMENT
    filterSevices: function () {
      if (this.service_add.department == 1) {
        return this.consultationServices;
      } else if (this.service_add.department == 2) {
        return this.radiologyServices;
      } else if (this.service_add.department == 3) {
        return this.procedureServices;
      } else if (this.service_add.department == 4) {
        return this.labServices;
      } else if (this.service_add.department == 6) {
        return this.dentalServices;
      } else if (this.service_add.department == 7) {
        return this.antenatalServices;
      }else if (this.service_add.department == 8) {
        return this.otherServices;
      } else {
        return [];
      }
    },
    // END FILTER SERVICES DEPENDING ON A SELECTED DEPARTMENT

    // GET SERVICE PRICE
    SevicesPrice: function () {
      if (this.service_add.department == 1) {
        return this.consultationServices.filter((ser) => {
          return ser.id == this.service_add.service;
        });
      } else if (this.service_add.department == 2) {
        return this.radiologyServices.filter((ser) => {
          return ser.id == this.service_add.service;
        });
      } else if (this.service_add.department == 3) {
        return this.procedureServices.filter((ser) => {
          return ser.id == this.service_add.service;
        });
      } else if (this.service_add.department == 4) {
        return this.labServices.filter((ser) => {
          return ser.id == this.service_add.service;
        });
      } else if (this.service_add.department == 6) {
        return this.dentalServices.filter((ser) => {
          return ser.id == this.service_add.service;
        });
      } else if (this.service_add.department == 7) {
        return this.antenatalServices.filter((ser) => {
          return ser.id == this.service_add.service;
        });
      }else if (this.service_add.department == 8) {
        return this.otherServices.filter((ser) => {
          return ser.id == this.service_add.service;
        });
      } else {
        return "0";
      }
    },

    // END GET SERVER
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.service_add.department = "";
        this.service_add.service = "";
        this.service_add.quantity = "1";
        this.service_add.service_cost = "";
        this.closeMode(this.model_id);
        this.closeMode(this.modal_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.submitted = false;
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
    ReferPrintId(newValue) {
      if (newValue != "") {
        this.$router.push(`/patients/refer_details/${newValue}`
        );
      }
    },
    DischargePrintId(newValue) {
      if (newValue != "") {
        this.$router.push(`/visit/discharge/${newValue}`
        );
      }
    },
    PatientCompalints(newValue) {
          this.options = newValue;
    },
    FinalDiagnosis(newValue) {
         this.finalDiagnosisTags = newValue;
    }  ,
    ProvisionalDiagnosis(newValue) {
    this.provisionalDiagnosisTags = newValue;
    }

  },
  methods: {
    ...mapActions({
      EditVisit: "patients/editVisit",
      FetchDiagnosisDetails: "doctor/fetchDiagnosisDetails",
      SaveClinicalNotes: "doctor/saveClinicalNotes",
      FetchDiagnosisDetailsNotes: "doctor/fetchDiagnosisDetailsNotes",
      FetchPatientsComplaints: "doctor/fetchPatientsComplaints",
      FetchProvisionalDiagnosis: "doctor/fetchProvisionalDiagnosis",
      FetchFinalDiagnosis: "doctor/fetchFinalDiagnosis",
      FetchOrderedConsultations: "visits/fetchOrderedConsultations",
      FetchOrderedProcedure: "visits/fetchOrderedProcedure",
      Add_Service: "visits/AddService",
      FetchOrderedRadiology: "visits/fetchOrderedRadiology",
      FetchAllOrderedServices: "visits/fetchAllOrderedServices",
      FetchOrderedDental: "visits/fetchOrderedDental",
      FetchPharmacyItems: "pharmacy/fetchPharmacyItems",
      FetchDosage: "pharmacy/fetchDrugageRange",
      FetchOtherSystems: "systems/fetchOtherSystems",
      AddPrescriptions: "prescriptions/addPrescriptions",
      UpdatePrescription: "prescriptions/updatePrescription",
      RemovePrescription: "prescriptions/removePrescription",
      FetchVisitPrescriptions: "prescriptions/fetchVisitPrescriptions",
      FetchPatientSystems: "systems/fetchPatientOtherSystems",
      AddPatientOtherSystems: "systems/addPatientOtherSystems",
      FetchStaff: "staffModule/fetchClinicStaff",

      // SERVICES
      FetchLabServices: "services/fetchLabServices",
      FetchConsultationServices: "services/fetchConsultationServices",
      FetchRadiologyServices: "services/fetchRadiologyServices",
      FetchProcedureServices: "services/fetchProcedureServices",
      FetchDentalServices: "services/fetchDentalServices",
      FetchAntentalServices: "services/fetchAntenatalServices",
      FetchOtherServices: "services/fetchOtherServices",
      FetchInsuranceServices: "insurance/fetchInsuranceServices",
      // systems managements
      UpdatePatientOtherSystems: "systems/updatePatientOtherSystems",
      SaveAppointments: "appointment/saveAppointments",
      FetchPatientAppointments: "appointment/fetchPatientAppointments",
      FetchHealthUnits: "inpatient/fetchHealthUnits",
      SaveReferralInformation: "inpatient/saveReferralInformation",
      FetchVisitProfile: "visits/fetchVisitProfile",
      SaveDischargeInformation: "inpatient/saveDischargeInformation",
    }),
    editVisit() {
      this.modal = "edit-visit-modal"
      this.EditVisit(this.editdata);
    },
    showEditModal(data) {
      this.modal_id = "edit-visit-modal";
      this.editdata.new_name = data.patient.patientName;
      this.editdata.pressure = data.pressure;
      this.editdata.temperature = data.temp;
      this.editdata.mauc = data.muac;
      this.editdata.age = data.age;
      this.editdata.id = data.id;
      this.editdata.age_unit = data.age_unit;
      this.editdata.weight = data.weight;
      this.editdata.height = data.height;
      this.editdata.nextofkin = data.nextOfKin;
      this.editdata.visitdate = data.editvisitDate;
      this.editdata.nextofkincontact = data.nextOfKinPhone;
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
    //PRESCRIBE
    Prescribing(modelId) {
      if (this.prescription.drug_id == "") {
        this.drugError = "Drug field is required";
        return;
      } else {
        this.drugError = "";
      }
      if (this.prescription.rec_dosage == "") {
        this.mdcnError = "Dosage field is required";
        return;
      } else {
        this.mdcnError = "";
      }
      if (this.prescription.quantity == "" || this.prescription.quantity < 1) {
        this.qtyError = "Quantity field is required";
        return;
      } else {
        this.qtyError = "";
      }
      if (this.prescription.is_insured == "") {
        this.InsError = "Payment Type";
        return;
      } else {
        this.InsError = "";
      }

      this.model_id = modelId;
      this.AddPrescriptions(this.prescription);
    },

    onFileChange(e) {
      this.radiology_attach.patient_service_id = this.clinic_data.selected;
      this.radiology_attach.file = e.target.files[0];
      this.radiology_attach.url = URL.createObjectURL(this.radiology_attach.file);
    },

    SetDocument(data) {
      this.selecteddoc = data;
    },

    formSubmit(e) {
      e.preventDefault();

      const config = {
        headers: {"content-type": "multipart/form-data"},
      };

      let formData = new FormData();
      formData.append("file", this.radiology_attach.file);
      formData.append("name", this.radiology_attach.name);
      formData.append("visit_id", this.radiology_attach.visit_id);
      formData.append("patient_service_id", this.radiology_attach.patient_service_id);

      axios
          .post("/radiology_attachments", formData, config)
          .then(() => {
            this.radiology_attach.file = ""
            this.radiology_attach.name = ""
            this.Fetch_attachments();
            let message = {msg: "Attachments uploaded Successfully"};
            this.FetchPharmacyItems();
            this.$store.dispatch("notification/success", message);
            this.radiology_attach = {
              name: "",
              file: "",
              success: "",
              filePreview: "",
              url: "",
              visit_id: this.$route.params.visit,
              patient_service_id: "",
            };
          })
          .catch(() => {
            let message = {msg: "Error uploading attachments"};
            this.$store.dispatch("notification/error", message);
          });
    },
    Fetch_attachments() {
      axios
          .get(`/viewAttachments/${this.$route.params.visit}/${this.clinic_data.selected}`)
          .then((res) => {
            this.attachments = res.data;
          })
          .catch(() => {
          });
    },
    setServiceResults(results) {
      this.serviceresults = results;
    },

    AddnewAppointment(modelId) {
      this.model_id = modelId;
      this.SaveAppointments(this.appointment_data);
    },
      Print_visiteport() {
          if (this.clinic_data.selected == "") {
              alert("select service");
              return;
          }
          this.$router.push(
              `/visit_report/${this.$route.params.id}/${this.$route.params.visit}/${this.clinic_data.selected}`
          );
      },
    SaveSystem(sys) {
      this.isEditing = false;
      this.UpdatePatientOtherSystems(sys);
    },
    SaveQtyMedic(drug) {
      this.UpdatePrescription(drug);
    },
    DeletePrescription(priscription, index) {
      this.RemovePrescription(priscription);
      this.$store.commit("prescriptions/REMOVE_VIST_PRES", index);
    },
    addComplaint(newTag) {
      let tag = {
        id: "",
        complaint: newTag,
      };
      this.options.push(tag);
      this.clinic_data.patient_complaints.push(tag);
    },
    addFinalDiagnosis(newdia) {
      let tag = {
        id: "",
        name: newdia,
      };
      this.finalDiagnosisTags.push(tag);
      this.clinic_data.patient_finalDiagnosis.push(tag);
    },
    addPrevisionalDiagnosis(newdia) {
      let tag = {
        id: "",
        name: newdia,
      };
      this.provisionalDiagnosisTags.push(tag);
      this.clinic_data.patient_provisionalDiagnosis.push(tag);
    },

    // ADD SERVICE
    addService(modelId) {
      this.model_id = modelId;
      if (this.service_add.department == "") {
        this.deptError = "Service Category field is required";
        return;
      } else {
        this.deptError = "";
      }
      if (this.service_add.service == "") {
        this.serviceError = "Service field is required";
        return;
      } else {
        this.serviceError = "";
      }
      if (this.service_add.quantity == "" || this.service_add.quantity < 1) {
        this.qtyError = "Quantity field is required";
        return;
      } else {
        this.qtyError = "";
      }
      if (this.service_add.is_insured == "") {
        this.InsError = "Payment Type";
        return;
      } else {
        this.InsError = "";
      }
      if (this.service_add.service_cost == "") {
        this.priceError = "Service Price field is required";
        return;
      } else {
        this.priceError = "";
      }

      // Check service price first
      // if (this.service_add.service_cost < this.service_add.minimum_price) {
      //   this.priceError = "Service price less than "+this.service_add.minimum_price+" is not accepted";
      //   return;
      // } else {
      //   this.priceError = "";
      // }

      this.Add_Service(this.service_add);
    },
    // END ADD SERVICE

    // CLOSE MODEL
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },
    // END CLOSE MODEL

    // SET CLINICAL NOTE
    setNotes() {

      this.Fetch_attachments();
      this.other_systems.service_id = this.clinic_data.selected;

      if (this.DiagnosisDetails.is_insured == 'insurance') {
        this.priscription.is_insured = 1
      } else {
        this.priscription.is_insured = 0
      }
      let notes = this.DiagnosisDetails.clinicnotes.filter((item) => {
        return item.service_id == this.clinic_data.selected;
      });
      let client_notes = notes[0];
      // this.test = client_notes;
      if (client_notes) {
        this.clinic_data.version = client_notes.version;
        this.clinic_data.physicalexamination = client_notes.patientExam
            ? client_notes.patientExam
            : "";
        this.clinic_data.finaldiagnosis = client_notes.finalDiagnosis
            ? client_notes.finalDiagnosis
            : "";
        this.clinic_data.summary = client_notes.DiagnosisSummary
            ? client_notes.DiagnosisSummary
            : "";
        this.clinic_data.provisional = client_notes.provisionalDignosis
            ? client_notes.provisionalDignosis
            : "";
        this.clinic_data.description = client_notes.desc ? client_notes.desc : "";
        this.clinic_data.recommendation = client_notes.recommendation
            ? client_notes.recommendation
            : "";
        this.clinic_data.complaints_history = client_notes
            ? client_notes.complaintsHistory
            : "";

        let temp_arry = [];

        if (client_notes.complaints) {
          client_notes.complaints.forEach((value) => {
            temp_arry.push(value.complaint);
          });
        }

        this.clinic_data.patient_complaints = temp_arry;

        let temp_fdarry = [];
        if (client_notes.patientFinalDiagnosis) {
          client_notes.patientFinalDiagnosis.forEach((value) => {
            temp_fdarry.push(value.p_final_diagnosis);
          });
        }
        this.clinic_data.patient_finalDiagnosis = temp_fdarry;

        let temp_pdarry = [];
        if (client_notes.patientProvisionalDiagnosis) {
          client_notes.patientProvisionalDiagnosis.forEach((value) => {
            temp_pdarry.push(value.p_provisional_diagnosis);
          });
        }
        this.clinic_data.patient_provisionalDiagnosis = temp_pdarry;

        // FITER OTHER SYSTEMS
        if (this.PatientOtherSystems) {
          this.ServiceSystemsArray = this.PatientOtherSystems.filter((item) => {
            return item.service.id == this.clinic_data.selected;
          });
        }
      }

      // alert(this.ServiceSystemsArray);
      // TURN OFF EDITING STATUS
      setTimeout(() => {
        this.isEditing = false;
      }, 2000);
    },

    track_unsave() {
      this.isEditing = true;
    },

    // SET SERVICE PRICE
    getPrice() {
      this.service_add.service_cost = this.SevicesPrice[0].servicePrice.replace(/,/g, '');
      this.service_add.minimum_price = this.SevicesPrice[0].servicePrice.replace(/,/g, '');
    },
    // END SET SERVICE PRICE

    // CLEAR SERVICES INPUTS
    clear_inputs() {
      this.service_add.service_cost = "";
    },
    // CLEAR SERVICES INPUT

    //  SAVE CLINICAL NOTES
    saveClinicalNotes() {
      this.SaveClinicalNotes(this.clinic_data);
      this.isEditing = false;
    },
    // END SET CLINICAL NOTES
    // ADD PRESCRIPTION
    add_newPrescription() {
      this.AddPrescriptions(this.priscription);
    },

    // ADD PRESCRIPTION
    add_newSystem() {
      this.AddPatientOtherSystems(this.other_systems);
    },

    setEditing() {
      this.isEditing = true;
    },

    // VOICE METHODS
    // SPEECH

    /**
     * Vue to speech events
     */
    listenForSpeechEvents() {
      this.warnDoctor.onstart = () => {
      };

      this.warnDoctor.onend = () => {
      };
    },

    /**
     * Shout at the user
     */
    Lets_speak() {
      // it should be 'craic', but it doesn't sound right
      this.warnDoctor.text =
          "Hello," +
          this.$store.getters["auth/firstname"] +
          " You have unsaved changes, please press cancel to go and save or press ok to continue";
      this.warnDoctor.voice = this.voiceList[this.selectedVoice];
      this.synth.speak(this.warnDoctor);
    },
    chagewarnSatatus() {
      let set = {status: this.warn_status};
      localStorage.setItem("warn_status", JSON.stringify(set));
    },
    setWarnStatus() {
      if (localStorage.getItem("warn_status")) {
        let k = JSON.parse(localStorage.getItem("warn_status"));
        this.warn_status = k.status;
      } else {
        let set = {status: this.warn_status};
        localStorage.setItem("warn_status", JSON.stringify(set));
      }
    },
    SaveRefer() {
      this.SaveReferralInformation(this.referral_data)
    },
    dischargePatient(modelId) {
      this.model_id = modelId;
      if (!this.SaveStatus) {
        this.SaveDischargeInformation(this.discharge_data);
      }

    },

    resetErrors() {
      this.qtyError = "";
      this.drugError = "";
      this.mdcnError = "";
      this.InsError = "";
      this.deptError = "";
      this.serviceError = "";
      this.priceError = "";
    },
    resetInputs() {
      this.prescription.quantity = "1";
      this.prescription.rec_dosage = "";
      this.prescription.drug_id = "";

      this.service_add.patient_service = '';
      this.service_add.quantity = '';
      this.service_add.service = '';
      this.service_add.service_cost = '';
      this.service_add.department = '';
    },
    fetchprescription(){
      this.drugError = "";
      this.prescription.rec_dosage = "";
      this.default_dosage = this.DrugAgeRange.filter((obj)=>{
       if(obj.drug_id == this.prescription.drug_id && obj.from < this.visit_profile.age && obj.to > this.visit_profile.age && obj.age_unit_no == this.visit_profile.age_unit){
          return this.prescription.rec_dosage = obj.prescription;
        }
      })
    }
  },

  updated() {
    setTimeout(() => {
      if (this.clinic_data.selected != "") {
        // FITER OTHER SYSTEMS
        this.ServiceSystemsArray = this.PatientOtherSystems.filter((item) => {
          return item.service.id == this.clinic_data.selected;
        });
      }
    }, 2000);
  },

  created() {
    this.setWarnStatus();
    this.FetchPatientAppointments(this.$route.params.id);
    this.FetchDiagnosisDetails(this.$route.params.visit);
    if (this.$route.params.type == "1") {
      this.FetchOrderedConsultations(this.$route.params.visit);
      this.serv_autoselect_type = 1;
    } else if (this.$route.params.type == "2") {
      this.serv_autoselect_type = 2;
      this.FetchOrderedRadiology(this.$route.params.visit);
    } else if (this.$route.params.type == "3") {
      this.serv_autoselect_type = 3;
      this.FetchOrderedProcedure(this.$route.params.visit);
    } else if (this.$route.params.type == "6") {
      this.serv_autoselect_type = 6;
      this.FetchOrderedDental(this.$route.params.visit);
    }
    this.FetchVisitPrescriptions(this.$route.params.visit);
    this.FetchPatientSystems(this.$route.params.visit);
    this.FetchAllOrderedServices(this.$route.params.visit);
    this.FetchPatientsComplaints();
    this.FetchProvisionalDiagnosis();
    this.FetchFinalDiagnosis();
    this.FetchPharmacyItems();
    this.FetchOtherSystems();
    this.FetchStaff();
    this.FetchHealthUnits();
    this.FetchVisitProfile(this.$route.params.visit);
    this.FetchDosage();

    // FETCH SERVICES
    setTimeout(() => {
      this.FetchAllOrderedServices(this.$route.params.visit);
      this.FetchLabServices();
      this.FetchConsultationServices();
      this.FetchRadiologyServices();
      this.FetchProcedureServices();
      this.FetchDentalServices();
      this.FetchAntentalServices();
      this.FetchOtherServices();
      this.FetchInsuranceServices();
    }, 3000);
  },

  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    });
  },

  beforeRouteLeave(to, from, next) {
    if (this.isEditing) {
      if (this.warn_status == 1) {
        this.Lets_speak();
      }
      if (
          !window.confirm(
              "You have unsaved changes, press cancel to first go and save or press ok to continue"
          )
      ) {
        return;
      }
    }
    next();
  },
  preventNav(event) {
    if (!this.isEditing) return;
    event.preventDefault();
    // Chrome requires returnValue to be set.
    event.returnValue = "";
  },

  // VOICE MANAGEMENT
  mounted() {
    // wait for voices to load
    // I can't get FF to work without calling this first
    // Chrome works on the onvoiceschanged function
    this.voiceList = this.synth.getVoices();

    this.synth.onvoiceschanged = () => {
      this.voiceList = this.synth.getVoices();
      // give a bit of delay to show loading screen
      // just for the sake of it, I suppose. Not the best reason
    };

    this.listenForSpeechEvents();
  },

  // END VOICE MANAGEMENT
};
</script>

<template>
  <Layout>
    <Toasts
        :show-progress="true"
        :rtl="true"
        :max-messages="20"
        :time-out="3000"
        :closeable="false"
        :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-lg-12 mb-1">
        <div class="float-end">
          <div class="form-check form-switch form-switch-md mb-3">
            <input
                @change="chagewarnSatatus()"
                v-model="warn_status"
                v-if="warn_status"
                class="form-check-input"
                type="checkbox"
                id="SwitchCheckSizemd"
                checked
            />
            <input
                v-else
                v-model="warn_status"
                @change="chagewarnSatatus()"
                class="form-check-input"
                type="checkbox"
                id="SwitchCheckSizemd"
            />
            <label class="form-check-label text-primary" for="SwitchCheckSizemd"
            >Voice Validation</label
            >
          </div>
        </div>
        <div class="d-print-none">
          <button @click="$router.go(-1)" class="btn btn-success mb-2">
            <i class="fas fa-arrow-circle-left"></i> Go Back
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">
              MEDICATION DETAILS FOR
              <span class="text-info font-weight-bold"
              >{{
                  DiagnosisDetails.patient.patientName
                      ? DiagnosisDetails.patient.patientName.toUpperCase()
                      : "-------"
                }}
              </span>
              <div class="d-flex justify-content-end">
                <button

                    v-b-modal.edit-visit-modal
                    class="btn btn-success btn-sm m-1"
                    @click="showEditModal(DiagnosisDetails)"
                >
                  <i class="fa fa-edit"></i> Edit Visit
                </button>
                <router-link
                    class="btn btn-info btn-sm m-1"
                    :to="{ name: 'PreviousVisits', params: { patient_id: this.$route.params.id }}">
                  <i class="fa fa-eye"></i> Previous Visits
                </router-link>

                  <button v-if="clinic_data.selected && type == '1' || type == '6'"
                          type="button"
                          class="btn btn-primary btn-sm"
                          @click="Print_visiteport()"
                  >
                      Generate Visit Report
                  </button>
              </div>
            </h4>
            <b-spinner
                v-if="DiagnosisStatus"
                class="m-0"
                variant="primary"
                role="status"
            ></b-spinner>

            <div
                class="row"
                v-show="
                DiagnosisDetails.temp ||
                DiagnosisDetails.pressure ||
                DiagnosisDetails.weight ||
                DiagnosisDetails.pulse ||
                DiagnosisDetails.muac
              "
            >
              <div class="col-lg-12">
                <div class="table-responsive">
                  <table class="table table-bordered">
                    <tbody>
                    <tr>
                      <td>
                        Temperature :
                        <span class="text-primary">{{
                            DiagnosisDetails.temp
                                ? DiagnosisDetails.temp + " &#x2103;"
                                : "---"
                          }}</span>
                      </td>
                      <td>
                        Blood Pressure :
                        <span class="text-primary">
                            {{
                            DiagnosisDetails.pressure
                                ? DiagnosisDetails.pressure + " mmHg"
                                : "---"
                          }}</span
                        >
                      </td>
                      <td>
                        Weight :
                        <span class="text-primary">
                            {{
                            DiagnosisDetails.weight
                                ? DiagnosisDetails.weight + " kg"
                                : "---"
                          }}</span
                        >
                      </td>
                      <td>
                        Height :
                        <span class="text-primary">
                            {{
                            DiagnosisDetails.height
                                ? DiagnosisDetails.height + "m"
                                : "---"
                          }}</span
                        >
                      </td>
                      <td>
                        BMI :
                        <span class="text-primary" v-html="DiagnosisDetails.bmi
                                ? DiagnosisDetails.bmi
                                : '---'"></span
                        >
                      </td>
                      <td>
                        Pulse :
                        <span class="text-primary">
                            {{
                            DiagnosisDetails.pulse
                                ? DiagnosisDetails.pulse + " b/min"
                                : "---"
                          }}</span
                        >
                      </td>
                      <td>
                        MUAC :
                        <span class="text-primary">{{
                            DiagnosisDetails.muac ? DiagnosisDetails.muac + " cm" : "---"
                          }}</span>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- {{ DiagnosisDetails.clinicnotes[0].complaints }} -->
            <b-tabs content-class="p-3 text-muted">
              <b-tab active class="border-0">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>

                  <span class="d-none d-sm-inline-block">CLINICAL NOTES</span>
                </template>
                <div class="row">
                  <div class="col-md-3"></div>
                  <div class="col-md-6">
                    <label for="service">ORDERED SERVICES</label>
                    <select
                        class="form-control"
                        v-model="clinic_data.selected"
                        @change="setNotes()"
                    >
                      <option value="">Select Services</option>
                      <option
                          v-show="type == '1'"
                          v-for="(ordered, index) in OrderedConsultations
                          ? OrderedConsultations
                          : []"
                          :key="index"
                          :value="ordered.service.id"
                      >
                        {{ ordered.service.name }}
                      </option>
                      <option
                          v-show="type == '2'"
                          v-for="(ordered, index) in OrderedRadiology
                          ? OrderedRadiology
                          : []"
                          :key="index"
                          :value="ordered.service.id"
                      >
                        {{ ordered.service.name }}
                      </option>
                      <option
                          v-show="type == '3'"
                          v-for="(ordered, index) in OrderedProcedure
                          ? OrderedProcedure
                          : []"
                          :key="index"
                          :value="ordered.service.id"
                      >
                        {{ ordered.service.name }}
                      </option>
                      <option
                          v-show="type == '6'"
                          v-for="(ordered, index) in OrderedDental ? OrderedDental : []"
                          :key="index"
                          :value="ordered.service.id"
                      >
                        {{ ordered.service.name }}
                      </option>
                    </select>
                    <br/>
                  </div>
                </div>
                <span v-show="clinic_data.selected != ''">
                  <span v-show="this.$route.params.type == 1">
                    <div class="form-group">
                      <label
                      ><h4 class="mt-3 text-info font-weight-bold">
                          PRESENTING COMPLAINTS
                        </h4></label
                      >
                      <multiselect
                          @input="track_unsave()"
                          v-model="clinic_data.patient_complaints"
                          :height="300"
                          :options="options ? options : []"
                          :multiple="true"
                          :taggable="true"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :preserve-search="true"
                          tag-placeholder="Add this as new complaint"
                          placeholder="Search or add a complaint"
                          @tag="addComplaint"
                          label="complaint"
                          track-by="complaint"
                          :preselect-first="false"
                      >
                        <template slot="selection" slot-scope="{ values, isOpen }"
                        ><span
                            class="multiselect__single"
                            v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} complaints selected</span
                        ></template
                        >
                      </multiselect>
                    </div>

                    <div class="form-group">
                      <label class="mt-3 text-info font-weight-bold"
                      ><h4 class="mt-3 text-info font-weight-bold">
                          HISTORY OF PRESENTING COMPLAINTS
                        </h4></label
                      >
                      <ckeditor
                          @input="setEditing"
                          v-model="clinic_data.complaints_history"
                          :editor="editor"
                      ></ckeditor>
                    </div>

                    <div class="form-group">
                      <label
                      ><h4 class="mt-3 text-info font-werightight-bold">
                          REVIEW OF OTHER SYSTEMS
                        </h4>
                        <b-spinner
                            v-if="PatientSystemStatus"
                            class="m-0"
                            variant="primary"
                            role="status"
                        ></b-spinner
                        ></label>
                      <model-list-select
                          @input="add_newSystem()"
                          :list="OtherSystems ? OtherSystems : []"
                          v-model="other_systems.system"
                          option-value="id"
                          option-text="systemName"
                          placeholder="select system"
                      >
                      </model-list-select>
                    </div>
                    <div
                        class="form-group table-responsive mt-2"
                        v-if="ServiceSystemsArray.length"
                    >
                      <table class="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col" class="text-info">SYSTEM</th>
                            <th scope="col" class="text-info">OBSERVATION</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                              v-for="(sys, index) in ServiceSystemsArray
                              ? ServiceSystemsArray
                              : []"
                              :key="index"
                          >
                            <th scope="row">
                              {{ sys.system ? sys.system.system_name : "--" }}
                            </th>
                            <td>
                              <ckeditor
                                  v-on:blur="SaveSystem(sys, index)"
                                  :key="index"
                                  @input="setEditing"
                                  v-model="sys.diagnosis"
                                  :editor="editor"
                              ></ckeditor>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="form-group">
                      <label
                      ><h4 class="mt-3 text-info font-weight-bold">SUMMARY</h4></label
                      >
                      <ckeditor
                          @input="setEditing"
                          v-model="clinic_data.summary"
                          :editor="editor"
                      ></ckeditor>
                    </div>
                    <div class="form-group">
                      <label
                      ><h4 class="mt-3 text-info font-weight-bold">
                          PHYSICAL EXAMINATION
                        </h4></label
                      >
                      <ckeditor
                          @input="setEditing"
                          v-model="clinic_data.physicalexamination"
                          :editor="editor"
                      ></ckeditor>
                    </div>
                    <div class="form-group">
                      <label
                      ><h4 class="mt-3 text-info font-weight-bold">
                          PROVISIONAL DIAGNOSIS
                        </h4></label
                      >
                      <ckeditor
                          v-if="clinic_data.version == '1'"
                          @input="setEditing"
                          v-model="clinic_data.provisional"
                          :editor="editor"
                      ></ckeditor>
                      <multiselect
                          v-else
                          @input="track_unsave()"
                          v-model="clinic_data.patient_provisionalDiagnosis"
                          :height="300"
                          :options="
                          provisionalDiagnosisTags ? provisionalDiagnosisTags : []
                        "
                          :multiple="true"
                          :taggable="true"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :preserve-search="true"
                          tag-placeholder="Add this as new provisional diagnosis"
                          placeholder="Search or add a provisional diagnosis"
                          @tag="addPrevisionalDiagnosis"
                          label="name"
                          track-by="name"
                          :preselect-first="false"
                      >
                        <template slot="selection" slot-scope="{ values, isOpen }"
                        ><span
                            class="multiselect__single"
                            v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} provisional diagnosis selected</span
                        ></template
                        >
                      </multiselect>
                    </div>
                    <div class="form-group">
                      <label
                      ><h4 class="mt-3 text-info font-weight-bold">
                          FINAL DIAGNOSIS
                        </h4></label
                      >
                      <ckeditor
                          v-if="clinic_data.version == '1'"
                          @input="setEditing"
                          v-model="clinic_data.finaldiagnosis"
                          :editor="editor"
                      ></ckeditor>
                      <multiselect
                          v-else
                          @input="track_unsave()"
                          v-model="clinic_data.patient_finalDiagnosis"
                          :height="300"
                          :options="finalDiagnosisTags ? finalDiagnosisTags : []"
                          :multiple="true"
                          :taggable="true"
                          :close-on-select="false"
                          :clear-on-select="false"
                          :preserve-search="true"
                          tag-placeholder="Add this as new final diagnosis"
                          placeholder="Search or add final diagnosis"
                          @tag="addFinalDiagnosis"
                          label="name"
                          track-by="name"
                          :preselect-first="false"
                      >
                        <template slot="selection" slot-scope="{ values, isOpen }"
                        ><span
                            class="multiselect__single"
                            v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} final diagnosis selected</span
                        ></template
                        >
                      </multiselect>
                    </div>
                  </span>

                  <div class="form-group" v-show="this.$route.params.type != 1 && this.$route.params.type != 6 ">
                    <label
                    ><h4 class="mt-3 text-info font-weight-bold">DESCRIPTION</h4></label
                    >
                    <ckeditor
                        @input="setEditing"
                        v-model="clinic_data.description"
                        :editor="editor"
                    ></ckeditor>
                  </div>

                    <span v-show="this.$route.params.type == 6">
                       <div class="form-group">
                      <label
                      ><h4 class="mt-3 text-info font-weight-bold">
                        CHEIF COMPLAINT (C/O)
                        </h4></label
                      >
                      <multiselect
                              @input="track_unsave()"
                              v-model="clinic_data.patient_complaints"
                              :height="300"
                              :options="options ? options : []"
                              :multiple="true"
                              :taggable="true"
                              :close-on-select="false"
                              :clear-on-select="false"
                              :preserve-search="true"
                              tag-placeholder="Add this as new complaint"
                              placeholder="Search or add a complaint"
                              @tag="addComplaint"
                              label="complaint"
                              track-by="complaint"
                              :preselect-first="false"
                      >
                        <template slot="selection" slot-scope="{ values, isOpen }"
                        ><span
                                class="multiselect__single"
                                v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} complaints selected</span
                        ></template
                        >
                      </multiselect>
                    </div>

                    <div class="form-group">
                      <label class="mt-3 text-info font-weight-bold"
                      ><h4 class="mt-3 text-info font-weight-bold">
                       MEDICAL HISTORY (M/H)
                      </h4></label>
                      <ckeditor
                              @input="setEditing"
                              v-model="clinic_data.mh"
                              :editor="editor"
                      ></ckeditor>
                    </div>
                  </span>

                    <div class="form-group" v-show="this.$route.params.type == 6">
                    <label><h4 class="mt-3 text-info font-weight-bold">EXAMINATION</h4></label>
                    <ckeditor @input="setEditing" v-model="clinic_data.examination" :editor="editor"></ckeditor>
                  </div>
                    <div class="form-group" v-show="this.$route.params.type == 6">
                    <label><h4 class="mt-3 text-info font-weight-bold">DIAGNOSIS (Dx)</h4></label>
                    <ckeditor @input="setEditing" v-model="clinic_data.diagnosis" :editor="editor"></ckeditor>
                  </div>

                  <div class="form-group">
                    <label>
                        <h4 class="mt-3 text-info font-weight-bold"><span v-if="this.$route.params.type == 6">TREATMENT PLAN(Rx)</span><span v-else>MANAGEMENT</span></h4>
                    </label>
                    <br/>
                    <label
                    >SELECT DRUG
                      <b-spinner
                          v-if="prescriptionStatus"
                          class="m-0"
                          variant="primary"
                          role="status"
                      ></b-spinner
                      ></label>
                    <model-list-select
                        :list="PharmacyItems ? PharmacyItems : []"
                        @input="add_newPrescription()"
                        v-model="priscription.drug_id"
                        option-value="id"
                        option-text="drug_name"
                        placeholder="select drug"
                    >
                    </model-list-select>
                  </div>

                  <div
                      class="form-group table-responsive mt-2"
                      v-if="VisitPrescription ? VisitPrescription.length : 0"
                  >
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th scope="col">DRUG</th>
                          <th scope="col">QUANTITY</th>
                          <th scope="col">DOSAGE</th>
                          <th scope="col">REMOVE</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                            v-for="(drug, index) in VisitPrescription
                            ? VisitPrescription
                            : []"
                            :key="index"
                        >
                          <th scope="row">
                            {{ drug.item.drug }}
                             <span
                                 class="badge rounded-pill bg-success"
                                 v-if="drug.insured == '1'"
                             >Insured</span
                             >
                   <span
                       class="badge rounded-pill bg-primary"
                       v-else>Personal</span>
                          </th>
                          <td>
                            <input
                                v-if="drug.status == 0"
                                v-on:blur="SaveQtyMedic(drug)"
                                :key="index"
                                v-model="drug.quantity"
                                placeholder="Enter Quantity"
                                type="text"
                                class="form-control"
                            />

                            <input
                                v-else
                                readonly
                                v-model="drug.quantity"
                                placeholder="Enter Quantity"
                                type="text"
                                class="form-control"
                            />
                          </td>
                          <td>
                            <textarea
                                v-if="drug.status == 0"
                                v-model="drug.rec_dosage"
                                v-on:blur="SaveQtyMedic(drug)"
                                :key="index"
                                placeholder="Enter dosage e.g Tabs PCM 1g TDs x 3/7"
                                class="form-control"
                                rows="3"
                            ></textarea>

                            <textarea
                                readonly
                                v-else
                                v-model="drug.rec_dosage"
                                placeholder="Enter dosage e.g Tabs PCM 1g TDs x 3/7"
                                class="form-control"
                                rows="3"
                            ></textarea>
                          </td>
                          <td>
                            <button
                                v-if="drug.status == 0"
                                @click="DeletePrescription(drug, index)"
                                class="btn btn-danger btn-sm"
                            >
                              Remove
                            </button>
                            <button v-else class="btn btn-link btn-sm">
                              <i>Dispensed</i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="form-group">
                    <label
                    ><h4 class="mt-3 text-info font-weight-bold">
                        RECOMMENDATION
                      </h4></label
                    >
                    <ckeditor
                        @input="setEditing"
                        v-model="clinic_data.recommendation"
                        :editor="editor"
                    ></ckeditor>
                  </div>

                  <div class="form-group mt-2 d-grid d-md-flex justify-content-md-end">
                      <button class="btn btn-success m-1" @click="Print_visiteport()">
                      PRINT <i class="fa fa-print"></i>
                    </button>
                    <button class="btn btn-primary" @click="saveClinicalNotes()">
                      SAVE NOTES <i class="fa fa-check"></i>
                    </button>
                    <b-spinner
                        v-if="NotesSaveStatus"
                        class="m-1"
                        variant="primary"
                        role="status"></b-spinner>
                  </div>
                  <div class="card" v-show="type == '2' || type == '1'">
                    <div class="card-body">
                      <h4 class="card-title">Upload Attachments</h4>
                      <div
                          v-if="radiology_attach.success != ''"
                          class="alert alert-success"
                          role="alert"
                      >
                        {{ radiology_attach.success }}
                      </div>
                      <form @submit="formSubmit" enctype="multipart/form-data">
                        <div id="app">
                          <div class="row">
                            <div class="col-md-4">
                              <strong>File:</strong>
                              <input
                                  type="file"
                                  class="form-control"
                                  @change="onFileChange"
                              />
                              <div id="preview">
                                <img
                                    v-if="radiology_attach.url"
                                    :src="radiology_attach.url"
                                />
                              </div>
                            </div>
                            <div class="col-md-4">
                              <strong>Name:</strong>
                              <input
                                  type="text"
                                  placeholder="Enter attachment name"
                                  class="form-control"
                                  v-model="radiology_attach.name"
                              />
                            </div>

                            <div class="col-md-4">
                              <br/>
                              <button type="submit" class="btn btn-primary">
                                <i class="light bx bxs-cloud-upload"></i> Upload Files
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                    <!-- end card-body -->
                    <div class="table-responsive">
                      <table class="table table-nowrap table-hover mb-0">
                        <thead>
                          <tr>
                            <th scope="col">S/N</th>
                            <th scope="col">FILE</th>
                            <th scope="col">NAME</th>
                            <th scope="col">TIME</th>
                            <th scope="col">ACTION</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                              v-for="(file, index) in attachments ? attachments.data : []"
                              :key="index"
                          >
                            <td>{{ index + 1 }}</td>
                            <td>
                              <div class="mt-4 mt-md-0">
                                <img
                                    v-if="file.extension == 'pdf'"
                                    class="img-thumbnail"
                                    alt="pdf"
                                    width="100"
                                    :src="file.pdf"
                                    data-holder-rendered="true"
                                />
                                <img
                                    v-else
                                    class="img-thumbnail"
                                    :alt="file.name"
                                    width="100"
                                    :src="file.file"
                                    data-holder-rendered="true"
                                />
                              </div>
                            </td>
                            <td>{{ file.name }}</td>
                            <td>{{ file.dateUpdated }}</td>
                            <td>
                              <b-button
                                  @click="SetDocument(file)"
                                  v-b-modal.modal-center
                                  variant="primary"
                              >View</b-button
                              >

                              <button class="btn btn-danger">Delete</button>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <b-modal
                          size="lg"
                          :title="selecteddoc.name"
                          id="modal-center"
                          title-class="font-18"
                          hide-footer
                      >
                          <div class="row">
                           <iframe v-if="selecteddoc.extension == 'pdf'" id="fred" style="border:1px solid #666CCC"
                                   title="PDF in an i-Frame" :src="selecteddoc.file" frameborder="1" scrolling="auto"
                                   width="100%" height="600px"></iframe>
                        <img
                            v-else
                            class="img-thumbnail"
                            :alt="selecteddoc.file"
                            width="600"
                            :src="selecteddoc.file"
                            data-holder-rendered="true"
                        />
                          </div>


                      </b-modal>

                      <!-- ADD SERVICE MODEL -->
                      <div class="col-sm-6 col-md-4 col-xl-3">
                        <div class="my-4 text-center">
                          <b-modal hide-footer id="add_service_model" @hidden="resetErrors(), resetInputs()"
                                   :title="'ORDER SERVICES FOR ' + DiagnosisDetails.patient.patientName.toUpperCase()"
                                   title-class="font-18">
                            <div class="form-group">
                              <label class="col-form-label" for="password">Payment Type</label>
                              <select class="form-control" v-model="service_add.insurance_status">
                                <option v-for="(ty, index) in PaymentType" :key="index" :value="ty.id">
                                  {{ ty.name }}
                                </option>
                              </select>
                              <div class="text-danger" v-if="InsError">
                                <em>{{ InsError }}</em>
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="col-form-label"
                              >Service Category
                              </label>
                              <model-list-select
                                  :list="departments ? departments : []"
                                  v-model="service_add.department"
                                  option-value="id"
                                  option-text="name"
                                  placeholder="select Category">
                              </model-list-select>
                              <div class="text-danger" v-if="deptError">
                                <em>{{ deptError }}</em>
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="col-form-label">Service</label>
                              <model-list-select
                                  :list="filterSevices ? filterSevices : []"
                                  v-model="service_add.service"
                                  @input="getPrice()"
                                  option-value="id"
                                  option-text="serviceName"
                                  placeholder="select Service">
                              </model-list-select>
                              <div class="text-danger" v-if="serviceError">
                                <em>{{ serviceError }}</em>
                              </div>
                            </div>
                            <div class="form-group" v-if="service_add.department">
                              <label class="col-form-label" for="quantity">Quantity</label>
                              <input
                                  v-model="service_add.quantity"
                                  id="quantity"
                                  type="number"
                                  name="quantity"
                                  class="form-control"
                                  placeholder="Quantity"/>
                              <div class="text-danger" v-if="qtyError">
                                <em>{{ qtyError }}</em>
                              </div>
                            </div>
                            <div class="form-group">
                              <label class="col-form-label" for="service_price">Service Price</label>
                              <input
                                  v-model="service_add.service_cost"
                                  id="service_price"
                                  type="number"
                                  name="service_price"
                                  class="form-control"
                                  placeholder="Service price"/>
                              <div class="text-danger" v-if="priceError">
                                <em>{{ priceError }}</em>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button
                                  type="button"
                                  class="btn btn-secondary float-start"
                                  @click="closeMode('add_service_model')"
                              >
                                cancel
                              </button>
                              <button
                                  @click="addService('add_service_model')"
                                  type="submit"
                                  class="btn btn-success"
                              >
                                Submit <i class="fa fa-check"></i>
                              </button>
                              <b-spinner
                                  v-if="OrderServiceStatus"
                                  class="m-0"
                                  variant="primary"
                                  role="status"
                              ></b-spinner>
                            </div>
                          </b-modal>
                        </div>
                      </div>
                      <!-- END ADD SERVICE MODEL -->
                    </div>
                  </div>
                </span>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">SERVICES</span>
                </template>
                <div class="row">
                  <div class="form-group col-md-12">
                    <b-button
                        v-b-modal.add_service_model
                        class="float-end"
                        variant="primary"
                    >
                      <i class="fa fa-plus-circle"></i> Add New Service
                    </b-button
                    >
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-nowrap table-hover mb-0">
                    <thead>
                    <tr>
                      <th scope="col">SERVICE</th>
                      <th scope="col">QTY</th>
                      <th scope="col">COST</th>
                      <th scope="col">TIME</th>
                      <th scope="col">STATUS</th>
                      <th scope="col">RESULT</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="(service, index) in AllOrderedServices
                          ? AllOrderedServices
                          : []"
                        :key="index"
                    >
                      <td>{{ service.service ? service.service : "--" }}</td>
                      <td>{{ service.quantity ? service.quantity : "--" }}</td>
                      <td>{{ service.cost ? service.cost : "--" }}</td>
                      <td>{{ service.date ? service.date : "--" }}</td>
                      <td>
                        {{ service.status == "0" ? "Pending..." : "Done" }}
                      </td>
                      <td>
                          <span v-if="service.result_type == 0">{{
                              service.result
                            }}</span>
                        <button
                            @click="setServiceResults(service)"
                            v-b-modal.results_model
                            v-else
                            class="btn btn-primary"
                        >
                          View Results
                        </button>
                      </td>
                    </tr>
                    </tbody>
                    <tbody>
                    <tr
                        v-for="(service, index) in DiagnosisDetails.labrequests
                          ? DiagnosisDetails.labrequests
                          : []"
                        :key="index"
                    >
                      <td>{{ service.test.name }}</td>
                      <td>{{ service.quantity ? service.quantity : "--" }}</td>
                      <td>{{ service.amount ? service.amount : "--" }}</td>
                      <td>{{ service.date ? service.date : "--" }}</td>
                      <td>Pending...</td>
                      <td>Pending...</td>
                    </tr>
                    </tbody>
                    <tbody>
                    <tr
                        v-for="(service, index) in DiagnosisDetails.completetests
                          ? DiagnosisDetails.completetests
                          : []"
                        :key="index"
                    >
                      <td>{{ service.test.name }}</td>
                      <td>{{ service.quantity ? service.quantity : "--" }}</td>
                      <td>{{ service.cost ? service.cost : "--" }}</td>
                      <td>{{ service.orderDate ? service.orderDate : "--" }}</td>
                      <td>Done</td>
                      <td></td>
                    </tr>
                    </tbody>
                  </table>
                  <!-- ADD SERVICE MODEL -->
                  <!-- ADD SERVICE MODEL -->
                  <div class="col-sm-6 col-md-4 col-xl-3">
                    <div class="my-4 text-center">
                      <b-modal
                          hide-footer
                          id="results_model"
                          title="Services"
                          title-class="font-18"
                      >
                        <div class="table-responsive">
                          <table
                              class="table table-nowrap table-hover mb-0"
                              v-if="serviceresults.result_type == 1"
                          >
                            <thead>
                            <tr>
                              <th scope="col">RESULT</th>
                              <th scope="col">SYMBOL</th>
                              <th scope="col">COMMENT</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                v-for="(SERV, index) in serviceresults.result"
                                :key="index"
                            >
                              <td>{{ SERV.option_name }}</td>
                              <td>{{ SERV.result_code }}</td>
                              <td>{{ SERV.comment }}</td>
                            </tr>
                            </tbody>
                          </table>
                          <table
                              class="table"
                              v-else-if="serviceresults.result_type == 2"
                          >
                            <tr>
                              <th>RESULT DESCRIPTION</th>
                            </tr>
                            <tr>
                              <td>
                                <p>{{ serviceresults.comment }}</p>
                              </td>
                            </tr>
                          </table>
                          <table
                              class="table"
                              v-else-if="serviceresults.result_type == 3"
                          >
                            <tr>
                              <th>RESULT DESCRIPTION</th>
                            </tr>
                            <tr>
                              <td>
                                <p>{{ serviceresults.comment }}</p>
                              </td>
                            </tr>
                          </table>
                          <table
                              class="table"
                              v-else-if="serviceresults.result_type == 4"
                          >
                            <tr>
                              <th>RESULT DESCRIPTION</th>
                            </tr>
                            <tr>
                              <td>
                                <p>{{ serviceresults.comment }}</p>
                              </td>
                            </tr>
                          </table>

                          <table
                              class="table table-nowrap table-hover mb-0"
                              v-else
                          ></table>
                        </div>
                      </b-modal>
                    </div>
                  </div>
                  <!-- END  SERVICE MODEL -->
                  <!-- END  SERVICE MODEL -->
                </div>
              </b-tab>
              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-cog"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">PRESCRIPTIONS</span>
                </template>
                <div class="row">
                  <div class="form-group col-md-12">
                    <button
                        v-b-modal.prescription
                        class="btn btn-success btn-sm float-end"
                    >
                      <i class="fa fa-plus-circle"></i> Add Prescription
                    </button>

                    <!-- Add prescription modal -->
                    <b-modal
                        hide-footer
                        id="prescription"
                        :title="'PRESCRIBE FOR ' + visit_profile.patient.patientName.toUpperCase()"
                        title-class="font-18"
                        @hidden="resetInputs(), resetErrors()"
                    >
                      <div class="form-group">
                        <label class="col-form-label" for="password">Payment Type</label>
                        <select class="form-control" v-model="prescription.is_insured">
                          <option
                              v-for="(ty, index) in PaymentType"
                              :key="index"
                              :value="ty.id"
                          >
                            {{ ty.name }}
                          </option>
                        </select>
                        <div class="text-danger" v-if="InsError">
                          <em>{{ InsError }}</em>
                        </div>
                      </div>
                      <div class="form-group">
                        <label class="col-form-label" for="userName">Pharmacy Item</label>
                        <model-list-select
                            :list="PharmacyItems ? PharmacyItems : []"
                            v-model="prescription.drug_id"
                            option-value="id"
                            option-text="drug_name"
                            placeholder="select Drug"
                            @input = "fetchprescription()"
                        >
                        </model-list-select>
                      </div>
                      <div class="text-danger" v-if="drugError">
                        <em>{{ drugError }}</em>
                      </div>
                      <div class="form-group">
                        <label class="col-form-label">Quantity</label>
                        <input
                            v-model="prescription.quantity"
                            type="number"
                            step="any"
                            name="service_price"
                            class="form-control"
                            placeholder="Quantity"
                            @input="resetErrors()"
                        />
                      </div>
                      <div class="text-danger" v-if="qtyError">
                        <em>{{ qtyError }}</em>
                      </div>
                      <div class="form-group">
                        <label class="col-form-label">Dosage</label>
                        <input
                            v-model="prescription.rec_dosage"
                            type="text"
                            name="service_price"
                            class="form-control"
                            placeholder="Enter dosage e.g Tabs PCM 1g TDs x 3/7"
                            @input="resetErrors()"
                        />
                      </div>
                      <div class="text-danger" v-if="mdcnError">
                        <em>{{ mdcnError }}</em>
                      </div>
                      <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary float-start"
                            @click="closeMode('prescription')"
                        >
                          cancel
                        </button>
                        <button
                            @click="Prescribing('prescription')"
                            type="submit"
                            class="btn btn-success"
                        >
                          Submit <i class="fa fa-check"></i>
                        </button>
                        <b-spinner
                            v-if="prescriptionStatus"
                            class="m-0"
                            variant="primary"
                            role="status"
                        ></b-spinner>
                      </div>
                    </b-modal>
                  </div>


                </div>
                <div class="table-responsive">
                  <table class="table table-nowrap table-hover mb-0">
                    <thead>
                    <tr>
                      <th scope="col">S/N</th>
                      <th scope="col">DRUG</th>
                      <th scope="col">QUANTITY</th>
                      <th scope="col">COST</th>
                      <th scope="col">PAYMENT TYPE</th>
                      <th scope="col">DOSAGE</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="(drug, index) in VisitPrescription
                          ? VisitPrescription
                          : []"
                        :key="index"
                    >
                      <th scope="row">{{ index + 1 }}</th>
                      <td>{{ drug.item.drug }}</td>
                      <td>{{ drug.itemQty }}</td>
                      <td>{{ drug.itemPrice }}</td>
                      <td>
                        {{ drug.isInsured == 1 ? "Insurance Bill" : "Personal Bill" }}
                      </td>
                      <td>{{ drug.medication ? drug.medication : "----" }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </b-tab>

              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-calendar"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Appointments</span>
                </template>
                <div class="row">
                  <div class="form-group col-md-12">
                    <b-button
                        v-b-modal.set_appointment_model
                        class="float-end"
                        variant="success"
                    >
                      <i class="fa fa-plus-circle"></i> Set New Appointment
                    </b-button
                    >
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-nowrap table-hover mb-0">
                    <thead>
                    <tr>
                      <th scope="col">S/N</th>
                      <th scope="col">STAFF NAME</th>
                      <th scope="col">VENUE</th>
                      <th scope="col">DATE/TIME</th>
                      <th scope="col">STATUS</th>
                      <th scope="col">ACTION</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(appo, index) in PatientAppointments" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ appo.doctor.staff_name }}</td>
                      <td>{{ appo.location }}</td>
                      <td>{{ appo.date }}</td>
                      <td>{{ appo.status }}</td>
                      <td>
                        <router-link
                            class="btn btn-info btn-sm"
                            :to="{ name: 'Appointment_Details', params: { id: appo.id } }"
                        >
                          Details
                        </router-link>
                      </td>
                    </tr>
                    </tbody>
                  </table>

                  <!-- SET APPOINTMENT MODEL -->
                  <div class="col-sm-6 col-md-4 col-xl-3">
                    <div class="my-4 text-center">
                      <b-modal
                          hide-footer
                          id="set_appointment_model"
                          :title="
                          'SET NEW APPOINTMENT WITH ' +
                          DiagnosisDetails.patient.patientName.toUpperCase()
                        "
                          title-class="font-18"
                      >
                        <div class="form-group">
                          <label class="col-form-label" for="password"
                          >Staff member</label
                          >
                          <model-list-select
                              :list="clinic_staff ? clinic_staff : []"
                              v-model="appointment_data.staff"
                              option-value="id"
                              option-text="staffName"
                              placeholder="select staff"
                          >
                          </model-list-select>
                        </div>
                        <div class="form-group">
                          <label class="col-form-label" for="userName">Location </label>
                          <input
                              v-model="appointment_data.location"
                              type="text"
                              class="form-control"
                              placeholder="Enter location"
                          />
                        </div>
                        <div class="form-group">
                          <label class="col-form-label" for="confirmpass">Date</label>
                          <input
                              v-model="appointment_data.appointment_date"
                              type="date"
                              class="form-control"
                          />
                        </div>
                        <div class="form-group">
                          <label class="col-form-label" for="confirmpass">Time</label>
                          <input
                              v-model="appointment_data.time"
                              type="time"
                              class="form-control"
                          />
                        </div>
                        <div class="modal-footer">
                          <button
                              type="button"
                              class="btn btn-secondary float-start"
                              @click="closeMode('set_appointment_model')"
                          >
                            cancel
                          </button>
                          <button
                              @click="AddnewAppointment('set_appointment_model')"
                              type="submit"
                              class="btn btn-success"
                          >
                            Submit <i class="fa fa-check"></i>
                          </button>
                          <b-spinner
                              v-if="Appointment_status"
                              class="m-0"
                              variant="primary"
                              role="status"
                          ></b-spinner>
                        </div>
                      </b-modal>
                    </div>
                  </div>
                  <!-- END ADD SERVICE MODEL -->
                </div>
              </b-tab>

              <!-- REFER PATIENT TAB -->
              <b-tab v-if="!profileStatus && visit_profile.refer">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-calendar"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">
                  <router-link
                      class="btn btn-info btn-sm"
                      :to="{ name: 'ReferForm_Details', params: { id: visit_profile.refer.id }}">
                      Refer Details
                  </router-link>
                  </span>
                </template>
              </b-tab>
              <b-tab v-if="!profileStatus && !visit_profile.refer">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-calendar"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Refer Patient</span>
                </template>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label>Referral Date</label>
                    <input v-model="referral_data.date" type="date" class="form-control"/>
                  </div>

                  <div class="form-group col-md-6">
                    <label>TO (Health unit)</label>
                    <input
                        list="dischagests"
                        type="text"
                        class="form-control"
                        placeholder="Enter health unit "
                        v-model="referral_data.to"
                    />
                    <datalist id="dischagests">
                      <option
                          v-for="(ref, index) in ReferHealthUnitsData"
                          :key="index"
                      >{{ ref.name }}
                      </option>
                    </datalist>
                  </div>

                </div>
                <div class="form-group">
                  <label>Investigations done</label>
                  <textarea
                      v-model="referral_data.investigations"
                      class="form-control"
                      id="exampleFormControlTextarea3"
                      rows="7"
                      placeholder="Enter investigations done"
                  ></textarea>
                </div>
                <div class="form-group">
                  <label>Reason</label>
                  <textarea
                      v-model="referral_data.reason"
                      class="form-control"
                      id="exampleFormControlTextarea3"
                      rows="7"
                      placeholder="Enter referal reason"
                  ></textarea>
                </div>
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                      @click="closeMode('referral_modal')"
                  >
                    Close
                  </button>
                  <button @click="SaveRefer()" type="button" class="btn btn-primary">Submit</button>
                </div>
              </b-tab>

              <!-- END REFER PATIENT TAB -->

              <!-- DISCHARGE PATIENT TAB -->
              <b-tab v-if="!profileStatus && visit_profile.discharge">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-calendar"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">
                  <router-link
                      class="btn btn-success btn-sm"
                      :to="{ name: 'DischargeVisit', params: { id: visit_profile.discharge.id }}">
                  Discharge Details
                  </router-link>
                  </span>
                </template>
              </b-tab>
              <b-tab v-if="!profileStatus && !visit_profile.discharge">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-calendar"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Discharge Patient</span>
                </template>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label>Admission Date</label>
                    <input
                        v-model="discharge_data.admission_date"
                        type="date"
                        class="form-control"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Discharge Date</label>
                    <input
                        v-model="discharge_data.discharge_date"
                        type="date"
                        class="form-control"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label>Ward</label>
                    <input
                        v-model="discharge_data.wards"
                        type="text"
                        class="form-control"
                        placeholder="Enter where to refer patient"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label>Status on discharge</label>
                    <input
                        list="dischagests"
                        type="text"
                        class="form-control"
                        placeholder="Enter Discharge Status"
                        v-model="discharge_data.status"
                    />
                    <datalist id="dischagests">
                      <option
                          v-for="(sts, index) in DischargeStatuses"
                          :key="index"
                          :value="sts.name"
                      ></option>
                    </datalist>
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-6">

                    <label>Discharge Officer</label>
                    <model-list-select
                        :list="clinic_staff?clinic_staff:[]"
                        v-model="discharge_data.officer"
                        option-value="id"
                        option-text="staffName"
                        placeholder="Select discharge officer"
                    >
                    </model-list-select>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Date of followup</label>
                    <input
                        v-model="discharge_data.followupdate"
                        type="date"
                        class="form-control"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="form-group">
                    <label>Follow up place</label>
                    <input
                        v-model="discharge_data.followupplace"
                        class="form-control"
                        type="text"
                        placeholder="Enter followup place"
                    />
                  </div>
                  <div class="form-group">
                    <label>Clinical Presentation</label>
                    <textarea
                        v-model="discharge_data.clinical_presentation"
                        class="form-control"
                        id="exampleFormControlTextarea3"
                        rows="5"
                        placeholder="Enter referal clinical presentation"
                    ></textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label>Summery of intervation given</label>
                    <textarea
                        v-model="discharge_data.intervation"
                        class="form-control"
                        id="exampleFormControlTextarea3"
                        rows="5"
                        placeholder="Enter referal intervation"
                    ></textarea>
                  </div>
                  <div class="form-group col-md-6">
                    <label>Recommendation on discharge</label>
                    <textarea
                        v-model="discharge_data.reccomendation"
                        class="form-control"
                        id="exampleFormControlTextarea3"
                        rows="5"
                        placeholder="Enter referal recommendation"
                    ></textarea>
                  </div>
                </div>

                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-secondary"
                      data-dismiss="modal"
                      @click="closeMode('discharge_modal')"
                  >
                    Close
                  </button>
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click="dischargePatient('discharge_modal')"
                  >
                    Submit
                    <b-spinner
                        v-if="SaveStatus"
                        style="float: right"
                        small
                        variant="light"
                        role="status"
                    ></b-spinner>
                  </button>
                </div>


              </b-tab>
              <!-- END DISCHARGE PATIENT TAB -->
            </b-tabs>
          </div>

          <!-- edit modal starts -->
          <b-modal id="edit-visit-modal" size="lg" hide-footer>
            <template #modal-title>
              Edit Visit Details for {{ editdata.new_name }}
            </template>
            <div class="row">
              <div class="col-6">
                <div class="form-group mb-3">
                  <label>Temperature</label>
                  <div class="input-group">
                    <input
                        placeholder="Enter temperature"
                        type="number"
                        class="form-control"
                        v-model="editdata.temperature"
                        step="any"
                    />
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group mb-3">
                  <label>Weight</label>
                  <div class="input-group">
                    <input
                        placeholder="Enter Weight"
                        type="text"
                        class="form-control"
                        v-model="editdata.weight"
                        step="any"
                    />
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group mb-3">
                  <label>Height</label>
                  <div class="input-group">
                    <input
                        placeholder="Enter Height"
                        type="text"
                        class="form-control"
                        v-model="editdata.height"
                        step="any"
                    />
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group mb-3">
                  <label>Pulse</label>
                  <div class="input-group">
                    <input
                        placeholder="Enter pulse"
                        type="number"
                        class="form-control"
                        v-model="editdata.pulse"
                        step="any"
                    />
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group mb-3">
                  <label>MUAC(cm)</label>
                  <div class="input-group">
                    <input
                        placeholder="Enter MUAC"
                        type="number"
                        class="form-control"
                        step="any"
                        v-model="editdata.mauc"
                    />
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group mb-3">
                  <label>Blood Pressure</label>
                  <div class="input-group">
                    <input
                        placeholder="Enter blood pressure"
                        type="text"
                        class="form-control"
                        step="any"
                        v-model="editdata.pressure"
                    />
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="form-group mb-3">
                  <label>Age</label>
                  <div class="input-group">
                    <input
                        placeholder="Enter age"
                        type="number"
                        class="form-control"
                        v-model="editdata.age"
                    />
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group mb-3">
                  <label>Next of Kin</label>
                  <div class="input-group">
                    <input
                        placeholder="Enter next of kin"
                        type="text"
                        class="form-control"
                        v-model="editdata.nextofkin"
                    />
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group mb-3">
                  <label>Age Unit</label>
                  <div class="input-group">
                    <select class="form-control" v-model="editdata.age_unit">
                      <option value="1">Years</option>
                      <option value="2">Months</option>
                      <option value="3">Days</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="form-group mb-3">
                  <label>Next of Kin Contact</label>
                  <div class="input-group">
                    <input
                        placeholder="Enter next of kin contact"
                        type="number"
                        class="form-control"
                        v-model="editdata.nextofkincontact"
                    />
                  </div>
                </div>
              </div>
              <div class="col-6">

                <div class="form-group mb-3">
                  <label>Visit Date</label>
                  <div class="input-group">
                    <input
                        type="date"
                        class="form-control"
                        v-model="editdata.visitdate"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('edit-visit-modal')"
              >
                <i class="fa fa-times"></i> Close
              </button>
              <button type="button" class="btn btn-primary" @click="editVisit()">
                Save Changes
                <b-spinner
                    v-if="saving_status"
                    style="float: right"
                    small
                    variant="light"
                    role="status"

                ></b-spinner>
              </button>
            </div>
          </b-modal>
          <!-- modal ends -->
        </div>
      </div>
    </div>
  </Layout>
</template>
<style scoped lang="css">
.ck-editor__editable {
    min-height: 500px;
}
#app {
  padding: 20px;
}

#preview {
  display: flex;
  padding-top: 20px;
  justify-content: center;
  align-items: center;
}

#preview img {
  max-width: 100%;
  max-height: 500px;
}
</style>